import { Image } from "./image.model";

export class MeterValidationList {
  id!: number;
  meterId!: number;
  accountNumber!: string;
  customerName!: string;
  address!: string;
  region!: string;
  district!: string;
  feederName!: string;
  dtName!: string;
  meterNumber!: string;
  customerPhase!: string;
  submittedDate!: string;
  assignedUser!: string;
  submittedBy!: string;
  validatedBy!: string;
  currentStatus!: string;
  assignedDate!:string;
}

export class MeterValidationDetails {
  id: number = 0;
  meterId: number = 0;
  areaId: number = 0;
  accountNumber: string = '';
  customerName: string = '';
  address: string = '';
  physicalAddress: string = '';
  region: string = '';
  district: string = '';
  dtName: string = '';
  feederName: string = '';
  correctDtName: string = '';
  correctFeederName: string = '';
  correctFeederVoltage: string = '';
  meterNumber: string = '';
  meterType: string = '';
  customerPhase: string = '';
  submittedDateTime: string = '';
  assignedUser: string = '';
  submittedBy: string = '';
  validatedBy: string = '';
  validationDateTime: string = '';
  status: string = '';
  installationAddress?: string = '';
  latitude: number = 0;
  longitude: number = 0;
  images: Image[] = [];
  isTampered: boolean = false;
  isInstallationOkay: boolean = false;
}

export enum ValidationFilter {
  NotSelected = -1,
  Valid = 0,
  Invalid = 1,
}

export class MeterValidationRegionData {
  regionName: string;
  validatedCount: number;
  totalCount: number;
  latitude: number;
  longitude: number;
  meterValidationPerArea!: MeterValidationAreaData[];

  constructor(regionName: string, totalCount: number, validatedCount: number, latitude: number = 0, longitude: number = 0) {
    this.regionName = regionName;
    this.totalCount = totalCount;
    this.validatedCount = validatedCount;
    this.latitude = latitude;
    this.longitude = longitude;
  }
}


export class MeterValidationAreaData {
    areaId: number;
    areaName: string;
    validatedCount: number;
    totalCount: number;


    constructor(areaId: number, areaName: string, totalCount: number, validatedCount: number) {
        this.areaId = areaId;
        this.areaName = areaName;
        this.totalCount = totalCount;
        this.validatedCount = validatedCount;
    }
}
